import { render, staticRenderFns } from "./LiveChats.vue?vue&type=template&id=832cbe2c&scoped=true"
import script from "./LiveChats.vue?vue&type=script&lang=js"
export * from "./LiveChats.vue?vue&type=script&lang=js"
import style0 from "./LiveChats.vue?vue&type=style&index=0&id=832cbe2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832cbe2c",
  null
  
)

export default component.exports